import { useIntl } from "react-intl";

type Props = {
  value?: boolean | null;
};

export const DataTableBooleanColumn = ({ value }: Props) => {
  const { formatMessage } = useIntl();

  if (value === null || value === undefined) {
    return "";
  }

  return value ? formatMessage({ id: "yes" }) : formatMessage({ id: "no" });
};
